import { faChevronLeft, faChevronRight, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getAuditoria } from "../../../services/auditoriaservice";
import { Link } from "react-router-dom";
import "../Auditoria/Auditoria.css";

export default function Auditoria(){

    const [auditorias, setAuditorias] = useState([]);
    const [busqueda, setBusqueda] = useState("");

    const [paginaActual, setPaginaActual] = useState(1);
    const [itemPorPagina] = useState(15);
    
    const indexUltimoItem = paginaActual * itemPorPagina;
    const indexPrimerItem = indexUltimoItem - itemPorPagina;

    const auditoriaFiltrada = auditorias.filter((item) => {
        const textoBusqueda = busqueda.toLowerCase();

        return(
            item.idmovimiento.toString().toLowerCase().includes(textoBusqueda) ||
            item.usuario.toString().toLowerCase().includes(textoBusqueda) ||
            item.descripcion.toString().toLowerCase().includes(textoBusqueda) ||
            item.fecha.toString().toLowerCase().includes(textoBusqueda) ||
            item.hora.toString().toLowerCase().includes(textoBusqueda)
        );
    });

    const cargarAuditoria = async () =>{
        try{
            const data = await getAuditoria();

            if (!data) return toast.error("No hay registros");
            
            const normalizados = data.map((a) => ({
                idmovimiento: a.idmovimiento,
                usuario: a.usuario,
                nombre: a.nombre,
                descripcion: a.descripcion,
                fecha: a.fecha,
                hora: a.hora
            }))

            setAuditorias(normalizados);
        } catch(error) {
            console.error("Error:", error);
            toast.error("No hay conexion con el servidor");
        }
    }

    const itemsActuales = auditoriaFiltrada.slice(indexPrimerItem, indexUltimoItem);
    const paginasTotales = Math.ceil(auditoriaFiltrada.length / itemPorPagina);

    const rangoPaginas = () =>{
        let inicio = Math.max(1, paginaActual - 1);
        let fin = Math.min(paginasTotales, inicio + 2);

        if (fin - inicio < 2) {
            inicio = Math.max(1, fin - 2);
        }

        const paginas = [];
        for(let i = inicio; i <= fin; i++){
            paginas.push(i);
        }
        return paginas;
    }

    const paginasVisibles = rangoPaginas();

    const siguiente = () => {
        if (paginaActual < paginasTotales){
            setPaginaActual(paginaActual + 1);
        }
    }

    useEffect(() => {
        cargarAuditoria();
    }, []);

    return(
        <div>
            <div className='container'>
                <div className="search-container">
                    <div className="search-wrapper">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input 
                            type="text" 
                            placeholder="Buscar cliente" 
                            className="search-input"
                            value={busqueda}
                            onChange={(e) =>{
                                setBusqueda(e.target.value);
                                setPaginaActual(1);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Usuario</th>
                            <th>Nombre</th>
                            <th>Descripcion</th>
                            <th>Fecha</th>
                            <th>Hora</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsActuales.map((item) => (
                            <tr key={item.idmovimiento}>
                                <td>{item.idmovimiento}</td>
                                <td>{item.usuario}</td>
                                <td>{item.nombre}</td>
                                <td className="col-descripcion">{item.descripcion}</td>
                                <td>{item.fecha}</td>
                                <td>{item.hora}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className="pagination-container">
                <div className="pagination-info">
                    Pagina {paginaActual} de {paginasTotales}
                </div>
                <div className="pagination-controls">
                    <button 
                        className="pag-btn prev-next"
                        onClick={() => setPaginaActual(prev => Math.max(prev - 1, 1))}
                        disabled={paginaActual === 1}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} /> Anterior
                    </button>
                    
                    {paginasVisibles.map(numero =>(
                        <button
                            key={numero}
                            onClick={() => setPaginaActual(numero)}
                            className={`pag-btn number ${paginaActual === numero ? 'active' : ''}`}
                            disabled={paginaActual === numero}
                        >
                            {numero}
                        </button>
                    ))}

                    <button 
                        className="pag-btn prev-next"
                        onClick={siguiente} 
                        disabled={paginaActual === paginasTotales || paginasTotales === 0}
                    >
                        Siguiente <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            </div>
        </div>
    );
}